import { HTTP_TOKEN } from "./http";

export const getVsls = (params) => {
  return HTTP_TOKEN.get("vsl", { params }).then((result) => {
    return result.data;
  });
};

export const getVsl = (vslId) => {
  return HTTP_TOKEN.get(`vsl/${vslId}`).then((result) => {
    return result.data;
  });
};



export const createVsl = (data) => {
  return HTTP_TOKEN.post("vsl", data).then((result) => {
    return result.data;
  });
};

export const updateVsl = (vslId, params) => {
  return HTTP_TOKEN.put(`vsl/${vslId}`, { params }).then((result) => {
    return result.data;
  });
};

export const deleteVsl = (vslId) => {
  return HTTP_TOKEN.delete(`vsl/${vslId}`, {}).then((result) => {
    return result.data;
  });
};